module.exports = [
  {
    fullName: "Paulo Querido",
    handle: "PauloQuerido",
    website: "https://twitter.com/PauloQuerido",
    bio: "Ex-journalist. Programmer.",
    avatar: "pquerido.jpg",
    story: "As a journalist and self-taught programmer, in the last 10 years I have proposed innumerable technological innovation projects to newspapers and televisions in my country, being rejected by all of them. Three years ago, at the age of 56, I scheduled the first chatbot in the European press and served as developer for 2 start-ups (games and virtual assistants). 1 year ago I was hired as an Artificial Intelligence programmer and developed voice assistants for contact centers.",
    double: false
},
{
      fullName: "Sebastian Motraghi",
      handle: "seb_m",
      website: "https://the1x.engineer",
      bio: "Twilio",
      avatar: "sebastian-motraghi.jpg",
      story: "Don't get discouraged if you get rejected from an opportunity you were really excited about. There are lots of awesome teams that would love to have you – sometimes it just takes a little extra searching.",
      double: false
  },
  {
      fullName: "Eduards Sizovs",
      handle: "eduardsi",
      website: "https://twitter.com/eduardsi",
      bio: "Founder of DevTube",
      avatar: "eduardsi.jpg",
      story:
        'Atlassian rejected me with "you don\'t know what you want". They were right. I built a dev community, international conference, a startup, traded crypto and retired in 30.',
      double: false
  },
  {
    fullName: "Kyle Simpson",
    handle: "getify",
    website: "https://twitter.com/getify",
    bio: "Author of You Don't Know JS",
    avatar: "getify.jpg",
    story:
      'Major social network company rejected me after an interview with, "We didn\'t think you knew enough JS."',
    double: false
  },
  {
    fullName: "Chris Wanstrath",
    handle: "defunkt",
    website: "https://twitter.com/defunkt",
    bio: "CEO, Github",
    avatar: "defunkt.jpg",
    story:
      "Before cofounding GitHub I applied for an engineering job at Yahoo and didn’t get it. Don’t let other people discourage you.",
    double: true
  },
  {
    fullName: "Jon Kuperman",
    handle: "jkup",
    website: "https://twitter.com/jkup",
    bio: "Twitter",
    avatar: "jkup.jpg",
    story: "I was rejected from 10 unpaid internships. Now I work at Twitter.",
    double: false
  },
  {
    fullName: "Brian Holt",
    handle: "holtbt",
    website: "https://twitter.com/holtbt",
    bio: "Netflix",
    avatar: "holtbt.jpg",
    story:
      "Rejected by LinkedIn for not knowing enough JS. Couldn't even get a phone screen with Google or Twitter. Went on to work for reddit and now Netflix.",
    double: false
  },
  {
    fullName: "Juriy Zaytsev",
    handle: "kangax",
    website: "https://twitter.com/kangax",
    bio: "Facebook",
    avatar: "kangax.jpg",
    story:
      "Fun fact: I did Google interview and was told I'm not that good of a JS developer :) So that's out of the way",
    double: false
  },
  {
    fullName: "Alex Sexton",
    handle: "SlexAxton",
    website: "https://twitter.com/SlexAxton",
    bio: "Stripe",
    avatar: "slexaxton.jpg",
    story:
      "I didn't get past the Twitter phone screen. Not in the beginning of my career, like 3 years ago.",
    double: false
  },
  {
    fullName: "Eric Rosenberg",
    handle: "DrJorts",
    website: "https://twitter.com/DrJorts",
    bio: "Twitter",
    avatar: "drjorts.jpg",
    story:
      "I was rejected without interview at Dropbox. Escorted out halfway through my Microsoft interview. Now I'm senior eng at Twitter.",
    double: false
  },
  {
    fullName: "Thomas Hunter",
    handle: "tlhunter",
    website: "https://twitter.com/tlhunter",
    bio: "Open Table",
    avatar: "tlhunter.jpg",
    story:
      "A year and a half after being rejected by a popular payment gateway company I finally got my senior software title at a company where I write ES6 all day.",
    double: false
  },
  {
    fullName: "Nick Morgan",
    handle: "skilldrick",
    website: "https://twitter.com/skilldrick",
    bio: "Twitter",
    avatar: "skilldrick.jpg",
    story:
      "Facebook rejected me just before Twitter hired me. I was very junior then though, so don't really blame them.",
    double: false
  },
  {
    fullName: "Anne-Gaelle Colom",
    handle: "agcolom",
    website: "https://twitter.com/agcolom",
    bio: "jQuery",
    avatar: "agcolom.jpg",
    story:
      "I was refused a reference by my supervisor in France who thought the male student on my team did all the work.",
    double: false
  },
  {
    fullName: "Kelly King",
    handle: "kng",
    website: "https://twitter.com/kng",
    bio: "Twitter",
    avatar: "kng.jpg",
    story:
      "I was rejected by YouTube and Pinterest before landing an awesome role at Twitter.",
    double: false
  },
  {
    fullName: "Sam Maskell",
    handle: "samuelmaskell",
    website: "https://twitter.com/samuelmaskell",
    bio: "Twitter",
    avatar: "samuelmaskell.jpg",
    story:
      "Over the course of 9 months, I had tons of interviews, most of which I thought went very well, and I just kept getting rejected. I was ready to drastically lower my bar. Then, within about 5 days, I got an offer from both Twitter and Amazon.",
    double: true
  },
  {
    fullName: "Vikas Gorur",
    handle: "vikasgorur",
    website: "https://twitter.com/vikasgorur",
    bio: "Twitter",
    avatar: "vikasgorur.jpg",
    story:
      "Got rejected by a storage startup despite extremely relevant experience. Interview was 5 whiteboard coding problems. I did well on three of them and okayish on the other two. Interviewed at Twitter three days and got an offer.",
    double: false
  },
  {
    fullName: "Caraesten",
    handle: "caraesten",
    website: "https://twitter.com/caraesten",
    bio: "Twitter",
    avatar: "caraesten.jpg",
    story:
      "I had an interview with Scribd, who I really liked at the time, and totally bombed. Blanked out on writing a linked list in Python.",
    double: false
  },
  {
    fullName: "Ben Sangster",
    handle: "sangster",
    website: "https://twitter.com/sangster",
    bio: "Twitter",
    avatar: "sangster.jpg",
    story:
      "I was rejected at Amazon and other companies with no technical interviews because I wasn't a Java engineer.",
    double: false
  },
  {
    fullName: "Miguel Rios",
    handle: "miguelrios",
    website: "https://twitter.com/miguelrios",
    bio: "Twitter",
    avatar: "miguelrios.jpg",
    story:
      "Before Twitter, I was rejected twice by big tech co, which only interviewed me cuz I had a scholarship they gave to Latino students.",
    double: false
  },
  {
    fullName: "Max Howell",
    handle: "mxcl",
    website: "https://twitter.com/mxcl",
    bio: "Apple",
    avatar: "mxcl.jpg",
    story:
      "Google: 90% of our engineers use the software you wrote (Homebrew), but you can’t invert a binary tree on a whiteboard so fuck off.",
    double: true
  },
  {
    fullName: "Bryan English",
    handle: "bengl",
    website: "https://twitter.com/bengl",
    bio: "Yahoo",
    avatar: "bengl.jpg",
    story:
      "Rejected by Google, Twitter, Square and Airbnb for bombing the on-site onslaughts of technical mindbogglery. One startup even cut me out mid-interview one time (can't remember which one). Now I'm at Yahoo doing npm things, which is a pretty sweet gig.",
    double: true
  },
  {
    fullName: "Myles Borins",
    handle: "thealphanerd",
    website: "https://twitter.com/thealphanerd",
    bio: "IBM",
    avatar: "thealphanerd.jpg",
    story:
      "First time interviewing I didn't get past the phone screen at google, twitter, or a number of other places. A startup offered me a 10 week internship way below market rate. I held out and got a decent job at Famous Industries where I got a ton of excellent opportunities.",
    double: false
  },
  {
    fullName: "Kevin van Zonneveld",
    handle: "kvz",
    website: "https://twitter.com/kvz",
    bio: "Transloadit",
    avatar: "kvz.jpg",
    story:
      "I was phone-screened by Google late 2010. I was nervous and unhappy with my performance but they never shared honest feedback or gave me a chance to set things straight.",
    double: false
  },
  {
    fullName: "Brandon Weis",
    handle: "brandonweis",
    website: "https://twitter.com/brandonweis",
    bio: "Cirqle",
    avatar: "brandonweis.jpg",
    story:
      "Rejected by Zenefits for not being expressive enough in implementing JavaScript serialized execution of async functions using callback. Got offered a senior position but didn't get it due to no work authorization. Both happened in the same afternoon. Still not giving up.",
    double: true
  },
  {
    fullName: "Zachary Forrest y Salazar",
    handle: "zdfs",
    website: "https://twitter.com/zdfs",
    bio: "Sonos",
    avatar: "zdfs.jpg",
    story: "Was rejected by Netflix, Twitter and TuneIn. Now I work at Sonos.",
    double: false
  },
  {
    fullName: "Charlie Robbins",
    handle: "indexzero",
    website: "https://twitter.com/indexzero",
    bio: "GoDaddy",
    avatar: "indexzero.jpg",
    story:
      "Was rejected by Google in New York in 2007 because I could not figure out how to list all subsets of a set correctly. I founded Nodejitsu and now work at GoDaddy.",
    double: false
  },
  {
    fullName: "John-David Dalton",
    handle: "jdalton",
    website: "https://twitter.com/jdalton",
    bio: "Microsoft",
    avatar: "jdalton.jpg",
    story:
      "I was rejected by Google, Mozilla, and Twitter before being hired by Microsoft. No ragrets.",
    double: false
  },
  {
    fullName: "Sebastian McKenzie",
    handle: "sebmck",
    website: "https://twitter.com/sebmck",
    bio: "Facebook",
    avatar: "sebmck.jpg",
    story:
      "Got rejected from a junior position at Atlassian for not knowing enough about JavaScript. Shortly after they now use the JavaScript compiler that I wrote across most of their JavaScript stack.",
    double: false
  },
  {
    fullName: "Mike MacCana",
    handle: "mikemaccana",
    website: "https://twitter.com/mikemaccana",
    bio: "CertSimple",
    avatar: "mikemaccana.jpg",
    story:
      "Got rejected by Google and within a few months was working there as a contractor. Later one of my projects was used in their recruiting ads as the kind of awesome work you can do at Google.",
    double: false
  },
  {
    fullName: "Shaun LeBron",
    handle: "shaunlebron",
    website: "https://twitter.com/shaunlebron",
    bio: "OSS",
    avatar: "shaunlebron.jpg",
    story:
      "I wondered what I was really worth after getting rejected by two silicon valley startups. So I decided to stop giving up on my side projects.",
    double: false
  },
  {
    fullName: "Ralph Holzmann",
    handle: "rlph",
    website: "https://twitter.com/rlph",
    bio: "Vine",
    avatar: "rlph.jpg",
    story:
      "I failed an interview at eGain for not knowing all the options on $.ajax. Went on to work for Bitovi and now Twitter / Vine.",
    double: false
  },
  {
    fullName: "Adam Reineke",
    handle: "AdamTReineke",
    website: "https://twitter.com/AdamTReineke",
    bio: "Microsoft",
    avatar: "AdamTReineke.jpg",
    story:
      'At a college career fair, a Midwest healthcare company handed my resume back because GPA was too low, saying "save the paper". I went on to spend two great internships at Microsoft where I\'ve continued full-time for over two years now.',
    double: true
  },
  {
    fullName: "Sinan Midillili",
    handle: "Sinanm89",
    website: "https://twitter.com/Sinanm89",
    bio: "OSS",
    avatar: "Sinanm89.jpg",
    story:
      "A swedish startup company dropped from skype mid call after I told them I was born in Turkey. Im still blocked to this day.",
    double: false
  },
  {
    fullName: "Lloyd Watkin",
    handle: "lloydwatkin",
    website: "https://twitter.com/lloydwatkin",
    bio: "IMDB",
    avatar: "lloydwatkin.jpg",
    story:
      "I was rejected by a top 10 website because I don't use semi-colons in my JavaScript. Now at IMDb / Amazon. Don't let them get you down :)",
    double: false
  },
  {
    fullName: "Michael Shao",
    handle: "abr71310",
    website: "https://twitter.com/abr71310",
    bio: "Amazon",
    avatar: "abr71310.jpg",
    story:
      "I got turned away from every return offer from internships I had (7), as well as 85 companies I applied to for full-time (even after getting to onsites for over 15 of them!). I now work at Amazon and love what I'm doing. :)",
    double: false
  },
  {
    fullName: "Sebastian Brandes Kraaijenzank",
    handle: "sebastianbk",
    website: "https://twitter.com/sebastianbk",
    bio: "Microsoft",
    avatar: "sebastianbk.jpg",
    story:
      "While finishing up my master's degree I was sending out tons of applications to big corps for software development jobs but I was rejected by virtually all of them. One week I was rejected by two companies I really wanted to work for so I was sad and got drunk in the weekend. The following Monday I had an offer from Microsoft sitting in my inbox.",
    double: true
  },
  {
    fullName: "Ian Devlin",
    handle: "iandevlin",
    website: "https://twitter.com/iandevlin",
    bio: "Trivago",
    avatar: "iandevlin.jpg",
    story:
      "Rejected by the Google HTML5 Developer Expert programme for not knowing enough about HTML5. Apparently being one of the HTML5 Doctors, writing many articles on the subject and having a book on HTML5 Multimedia being published wasn't enough for them.",
    double: false
  },
  {
    fullName: "Chris Hartjes",
    handle: "grmpyprogrammer",
    website: "https://twitter.com/grmpyprogrammer",
    bio: "Mozilla",
    avatar: "grmpyprogrammer.jpg",
    story:
      "I interviewed at Mozilla in 2008. I ran a gauntlet of 10 interviews in 8 hours. Didn’t get it. Ended up there Nov. 2015 anyway ;)",
    double: false
  },
  {
    fullName: "Rey Bango",
    handle: "reybango",
    website: "https://twitter.com/reybango",
    bio: "Microsoft",
    avatar: "reybango.jpg",
    story:
      "I was rejected by Arthur Andersen Consulting in the '90s because I didn't have an undergraduate degree and also by a number of well-known Silicon Valley companies because I couldn't relocate. Since then I've worked at great companies like Mozilla, Telerik & Microsoft, all remotely and with no undergrad degree.",
    double: true
  },
  {
    fullName: "Derick Bailey",
    handle: "derickbailey",
    website: "https://twitter.com/derickbailey",
    bio: "WatchMeCode",
    avatar: "derickbailey.jpg",
    story:
      "I was told by a hiring manager at Netflix that my career would be over if I wasn't willing to relocate my family to San Francisco. Since then, I've had 2 full time jobs that were 100% remote (work from home), have been a full time consultant with clients around the world (Germany, Japan, Denmark, South America, Canada, and all over the U.S.) Now, I'm an entrepreneur as well as consultant, I work less hours than any full time job I've ever had, and I earn more than ever.",
    double: true
  },
  {
    fullName: "Dave Geddes",
    handle: "geddski",
    website: "https://twitter.com/geddski",
    bio: "Domo",
    avatar: "geddski.jpg",
    story:
      "I totally bombed an interview at Trello about implementing linked lists in JavaScript. Today I’m a JS Architect at Domo.",
    double: false
  },
  {
    fullName: "Jake Johnson",
    handle: "xyclos",
    website: "https://twitter.com/xyclos",
    bio: "OSS",
    avatar: "xyclos.jpg",
    story:
      'I was rejected by Amazon. I waited around for an hour for a phone interview with their "head of acquisitions". He emailed me later that night saying he didn\'t have my phone number. My number was in the email he replied to 😒. He ignored all my attempts to reschedule.',
    double: false
  },
  {
    fullName: "Rachel White",
    handle: "ohhoe",
    website: "https://twitter.com/ohhoe",
    bio: "IBM",
    avatar: "ohhoe.jpg",
    story:
      "When I graduated from a less than desirable college, no employers in New York would take me seriously... so I moved to St. Louis. Everyone in the midwest didn't care where I went to school, and instead I was highly in demand as a developer with a design background. I worked in agencies for 3 years, until I got a job offer from Adobe and moved back to NYC. Now I'm at IBM Watson, and it's the best.",
    double: true
  },
  {
    fullName: "Spencer Gibb",
    handle: "spencerbgibb",
    website: "https://twitter.com/spencerbgibb",
    bio: "Pivotal",
    avatar: "spencerbgibb.jpg",
    story:
      "Interviewed at Netflix, didn't get the job. At Pivotal, I helped create Spring Cloud Netflix which integrates Netflix Open Source with Spring Boot. Now Netflix uses Spring Cloud Netflix... at Netflix.",
    double: false
  },
  {
    fullName: "Jason Shen",
    handle: "jasonshen",
    website: "https://twitter.com/jasonshen",
    bio: "IBM",
    avatar: "jasonshen.jpg",
    story:
      "Applied to the Harvard Business School as a Stanford honors grad with a 740 GMAT, no interview. Was rejected from Airbnb for a customer support role and later was passed over for a PM role at Google after 2 phone screens.\nI've cofounded Y Combinator startup (Ridejoy YC S11) and was selected by the White House to serve as a Presidential Innovation Fellow. Today I'm a product manager at Etsy. Timing and fit are everything.",
    double: true
  },
  {
    fullName: "Dhananjay Nakrani",
    handle: "playingDJ",
    website: "https://twitter.com/playingDJ",
    bio: "Google",
    avatar: "dhananjaynakrani.jpg",
    story:
      "During campus-placements in undergrad, interviewed with Samsung-India. Due to favoritism, I was rejected. Almost lost faith from meritocracy. Later got to do Google Summer of Code (Summer'14) and Google Internship (Summer'15). In grad school, received full time offers from both Yahoo & Google. Now, headed to Google for full time. Still, I have a long way to go. ;) My point is, don't lose faith because of a few incidents. Keep working. \"Adventure is out there!\"",
    double: true
  },
  {
    fullName: "Angel Colberg",
    handle: "angelcolberg",
    website: "https://twitter.com/angelcolberg",
    bio: "Mozilla",
    avatar: "angelcolberg.jpg",
    story:
      "I've been rejected by Google, Apple and FB. Ended up working with Microsoft, Apple, Google and Mozilla. Never take it personal.",
    double: false
  },
  {
    fullName: "Neil Kistner",
    handle: "wyze",
    website: "https://twitter.com/wyze",
    bio: "Monsanto",
    avatar: "wyze.jpg",
    story:
      "I was rejected by Facebook and Netflix at the technical interview/coding exercises. Now I write ES2015 && React all day at Monsanto.",
    double: false
  },
  {
    fullName: "Brian Salcedo",
    handle: "salcedo",
    website: "https://github.com/salcedo",
    bio: "OSS",
    avatar: "salcedo.jpg",
    story:
      "Got rejected by Linode because I'm a convicted hacker. Shortly thereafter, I won $50 Linode credit and a Raspberry Pi 2 through a Linode-sponsored challenge on True Ability. They probably think I hacked that too.",
    double: false
  },
  {
    fullName: "Steven Hauser",
    handle: "stevenhauser",
    website: "https://github.com/stevenhauser",
    bio: "OSS",
    avatar: "stevenhauser.jpg",
    story:
      "Rejected by GitHub for a frontend developer opening because my HTML, CSS, and JS skills were strong, but I failed to demonstrate my Ruby skills.",
    double: false
  },
  {
    fullName: "Ricardo Correa",
    handle: "rcorrear",
    website: "https://twitter.com/rcorrear",
    bio: "OSS",
    avatar: "rcorrear.jpg",
    story:
      "After applying for a Senior Development Engineer position at Amazon I get an email from HR for the Senior Cloud Support Engineer position. After two (technical) phone interviews and an 8 hour on-site multi team interview I get back the results: You really did very well in the interviews, but we're not extending an offer because you are a better fit for our Senior Development Engineer position!!",
    double: true
  },
  {
    fullName: "Rajat Arora",
    handle: "rajatonit",
    website: "https://twitter.com/rajatonit",
    bio: "BlackBerry",
    avatar: "rajatonit.jpg",
    story:
      "Was rejected by many companies which one of them was AutoDesk whom escorted me out of their office midway through the interview for having more knowledge of java over C++. I kept at it and now work at BlackBerry as my job. #StickWithIt",
    double: false
  },
  {
    fullName: "Patrick Haney",
    handle: "notasausage",
    website: "https://twitter.com/notasausage",
    bio: "OSS",
    avatar: "notasausage.jpg",
    story:
      'Apple interviewed me 4 times for 3 positions, all while I was employed at Harvard University. I even had to talk through designing the "iStove" for Steve Jobs and explain how Google Maps worked using a whiteboard. They never hired me and I left Harvard to work for myself a year later.',
    double: false
  },
  {
    fullName: "Lindsey Campbell",
    handle: "_lindseytron",
    website: "https://twitter.com/_lindseytron",
    bio: "InVision",
    avatar: "lindseytron.jpg",
    story:
      "Interviewed and rejected by two local startups in medical and education spaces. They talked down to me during my interview, wouldn't respond to emails, and left me hanging. The following week I landed my job at InVision. :)",
    double: false
  },
  {
    fullName: "John Slegers",
    handle: "johnslegers",
    website: "https://twitter.com/johnslegers",
    bio: "Cascade & PHPPowerTools",
    avatar: "johnslegers.jpg",
    story:
      "For frontend developer jobs, I'm usually told I don't have enough design skills. For backend developer jobs, I'm usually told I don't have enough experience in this or that framework. I'm currently unemployed.",
    double: false
  },
  {
    fullName: "Peter Kim",
    handle: "pkayfire",
    website: "https://github.com/pkayfire",
    bio: "OSS",
    avatar: "pkayfire.jpg",
    story:
      "Rejected by AngelList because I froze up during an interview and forgot the fibonacci sequence (seriously). Received an offer from Stripe a month later. Now cofounder at a top 500 US site. Never ever give up.",
    double: false
  },
  {
    fullName: "Mark DiMarco",
    handle: "markmarkoh",
    website: "https://twitter.com/markmarkoh",
    bio: "OSS",
    avatar: "markmarkoh.jpg",
    story:
      "I was literally asked to leave the office 15 minutes into the interview. The guy said \"I don't think either of us should waste any more of our time\" and turned around to face his computer. I sat in the parking lot for 30 minutes thinking I'd never be a developer.",
    double: false
  },
  {
    fullName: "Adam Sontag",
    handle: "ajpiano",
    website: "https://twitter.com/ajpiano",
    bio: "Bocoup",
    avatar: "ajpiano.jpg",
    story:
      "I wanted to be a professional football player but the New York Jets didn't want me because I couldn't run a sub-4.3 second 40 yard dash. Now I am Director of Community at Bocoup so I like to think I landed on my feet.",
    double: false
  },
  {
    fullName: "Scott Kosman",
    handle: "humantorch",
    website: "https://twitter.com/humantorch",
    bio: "adidas",
    avatar: "humantorch.jpg",
    story:
      "Survived multiple phone and Skype interviews with Apple (from Europe) as well as a take-home developer assignment. Flew to Cupertino for a round of in-person, highly technical interviews less than 24 hours after a 14 hour flight. Got my rejection notice 3 hours afterwards. Ended up as a Director in a production company and am now a Senior Digital Manager at adidas.",
    double: true
  },
  {
    fullName: "Lyn Muldrow",
    handle: "lynmuldrow",
    website: "https://twitter.com/lynmuldrow",
    bio: "Front-end Developer",
    avatar: "lyn.jpg",
    story:
      "After bootcamp, I was rejected over 50 times in three months by companies like Pandora, Twilio, and Zendesk for not having enough experience. Received an offer with an amazing company and now I motivate youth and others like me to succeed. Never let anyone tell you that you're not worthy. Keep going.",
    double: false
  },
  {
    fullName: "Robert Wilkins",
    handle: "rwilki ",
    website: "https://github.com/rwilki ",
    bio: "Self Employed",
    avatar: "rwilki.jpg",
    story:
      "I submitted applications to Sucuri, Buffer, and Road Runner Sports in hopes of furthering my career as a web and graphic designer. Ultimately, my career path has evolved just fine as I'm busier now more than ever working for myself. I'm challenged, rewarded, and love what I do. If I could manage the stress, it would be all good.",
    double: false
  },
  {
    fullName: "Sagar Savla",
    handle: "sagz",
    website: "http://sagz.in",
    bio: "Facebook",
    avatar: "sagar.jpg",
    story:
      "As I was finishing my Masters' I applied to so many companies that I was getting a rejection at least once a day. If I search my inbox for the word 'regret', I get over a hundred emails of these rejections. But I kept applying and kept interviewing. I finally got some offers and worked at companies like PayPal, Lyft and Facebook; after a lot of perseverance. You don't have to be great to start, but you have to start to be great.",
    double: true
  },
  {
    fullName: "Eray Arslan",
    handle: "erayarslan",
    website: "http://eray.ninja",
    bio: "markakod",
    avatar: "eray.jpg",
    story:
      "Rejected by Valve Software for a Software Engineer position because i was young. (when i was 19)",
    double: false
  },
  {
    fullName: "Sam Saccone",
    handle: "samccone",
    website: "http://samsaccone.com",
    bio: "🐐",
    avatar: "samccone.jpg",
    story:
      "I could not even get an unpaid internship at a newspaper because I was going to add too much overhead. 🆒",
    double: false
  },
  {
    fullName: "aditya1",
    handle: "aditya1",
    website: "https://github.com/jkup/rejected.us",
    bio: "Anonymous",
    avatar: "anonymous.jpg",
    story:
      "I'm originally from India. I have been rejected by 10-15 universities before landing in Virginia Tech. It took me 3 years to get my first admit. During my grad school I have been rejected by Google for not knowing their book search algorithm :-). Rejected by Microsoft for whatever reason and I blew up Amazon interview. Now work at European company in New England. Still eager to go to Silicon Valley, maybe 2016 is my year.",
    double: true
  },
  {
    fullName: "Coby Benveniste",
    handle: "daVinciCEB",
    website: "https://twitter.com/daVinciCEB",
    bio: "OSS",
    avatar: "daVinciCEB.jpg",
    story:
      "I was at the University of Illinois at Urbana-Champaign for a year. The school academics office was telling me that I had to take three semesters of Physics, including Quantum Physics and Thermodynamics, and that if I didn't like that, then I didn't belong at the school. I dropped out, and was almost immediately hired as a freelance contractor at a billion dollar investment company, and told that I could name my own price. Suck it, UIUC.",
    double: true
  },
  {
    fullName: "Adrian C",
    handle: "marshmallowmouth",
    website: "https://github.com/marshmallowmouth",
    bio: "OSS",
    avatar: "marshmallowmouth.jpg",
    story:
      'In my junior year of college, I had a phone interview with Apple for an internship. They asked me a question that took me a bit of time to answer, and the interviewer cut me off in the middle, saying "if you can\'t answer a question that is so simple quickly how could you expect to be hired by Apple." I went on to be hired at Microsoft, and then Apple and then get into a Ph.D. program.',
    double: false
  },
  {
    fullName: "Abad Federico",
    handle: "abad",
    website: "https://twitter.com/abad",
    bio: "Popcorn Time",
    avatar: "abad.jpg",
    story:
      "Rejected by Twitter, got depressed but then I created Popcorn Time!. Don't lose hope and keep your head up, adventures are around the corner!",
    double: false
  },
  {
    fullName: "Mark K Cowan",
    handle: "battlesnake",
    website: "https://github.com/battlesnake",
    bio: "OSS",
    avatar: "battlesnake.jpg",
    story:
      "Rejected by various small companies, have since rejected Google and Amazon and am working on space technologies",
    double: false
  },
  {
    fullName: "Greg Tarnoff",
    handle: "gregtarnoff",
    website: "http://tarnoff.info",
    bio: "Accessibility Consultant",
    avatar: "gregtarnoff.jpg",
    story:
      "I applied to a job for Web Accessibilty Engineer with Expedia and was rejected due to 'not having enough experience'.",
    double: false
  },
  {
    fullName: "Victor Trac",
    handle: "victortrac",
    website: "https://twitter.com/victortrac",
    bio: "Wikibuy",
    avatar: "victortrac.jpg",
    story:
      "As a freshly minted EE, American Megatrends rejected me as a BIOS engineer. I decided to move to and work in Europe for 4 years, where I got to travel extensively, and then took a job at a startup in Austin, TX, having never visited the state before. The startup grew and even IPO'd, and since then I've had a great time back in the startup game.",
    double: true
  },
  {
    fullName: "Marco Hengstenberg",
    handle: "nice2meatu",
    website: "https://twitter.com/nice2meatu",
    bio: "Smashing Magazine",
    avatar: "nice2meatu.jpg",
    story:
      "In late 2012, during a phone interview, I was told that, by judging from my résumé, I might better look for a trainee position. One week later I applied at Smashing Magazine and was hired right away – full time.",
    double: false
  },
  {
    fullName: "Luke Schunk",
    handle: "LukeSchunk",
    website: "https://github.com/lukeschunk",
    bio: "Software Engineer",
    avatar: "lukeyschunk.jpg",
    story:
      "When I was a designer, I was rejected from countless internships and junior positions at agencies like Huge, RGA, and more. Decided to learn to code and can't wait to apply to some of those companies again - as a developer.",
    double: true
  },
  {
    fullName: "Troy Connor",
    handle: "troy0820",
    website: "https://github.com/troy0820",
    bio: "Software Engineer",
    avatar: "troy0820.jpg",
    story:
      "Got rejected from Dominion Enterprises fresh out of college trying to do some PHP.  I attended Meetups with Norfolk.js and found myself in a great community.  I contributed to open source and was very apprehensive about leaving my government job to become a developer.  I met great people who encouraged me and helped me get rid of my imposter syndrome.  Now I'm a full-time Software Engineer with Emerging Technology Advisors.  Keep fighting for it.",
    double: true
  },
  {
    fullName: "Tim Chevalier",
    handle: "fatneckbeardguy",
    website: "https://catamorphism.org/",
    bio: "Software Engineer",
    avatar: "TimChristine.jpg",
    story:
      "Rejected by MIT for undergrad, accepted to the computer science Ph.D program. (I chose Berkeley for grad school instead.) Rejected by Google in 2003, 2006, and 2007; hired by Google in 2015. Previously rejected by Facebook, Twitter, and Apple.",
    double: true
  },
  {
    fullName: "Nathan Friedly",
    handle: "nfriedly",
    website: "https://www.nfriedly.com/",
    bio: "Senior Software Engineer",
    avatar: "nfriedly.jpg",
    story:
      'I was rejected for a Software Developer role at smaller company because I was "junior-level" and had bad motivation. A few months later I joined IBM as an Advisory Engineer and helped launch IBM Watson.',
    double: false
  },
  {
    fullName: "Frances Coronel",
    handle: "fvcproductions",
    website: "https://www.fvcproductions.com/?ref=rejected.us",
    bio: "Software Engineer at Slack",
    avatar: "fvcproductions.jpg",
    story:
      "I was rejected for a developer advocate role at a startup that helps people sign documents where I was 1 of 2 finalists after a lengthy interview process. When I asked for feeback on what I could have done better, the recruiter told me that in all his years as a recruiter, he's never been in a position where he wasn't able to provide any feedback. Later, I found out that the guy who got hired went to the same school as the hiring manager. This was the first time I felt a strong sense of imposter syndrome in the tech industry. One month later, I got an offer from Slack. Perseverance is key.",
    double: true
  },
  {
    fullName: "Jordan Gregory",
    handle: "gregoryjordanm",
    website: "https://twitter.com/j4n_g5y",
    bio: "Dad, Husband, 20 year linux veteran, 19 year python veteran",
    avatar: "gregoryjordanm.jpg",
    story:
      'Rejected by the leading debian-based linux distribution because "I don\'t have a college degree", otherwise, they loved  my experience.',
    double: false
  },
  {
    fullName: "Alan Ng",
    handle: "DeveloperAlan",
    website: "https://github.com/DeveloperAlan/",
    bio: "Software Engineer",
    avatar: "developeralan.jpeg",
    story:
      'Rejected by Freelancer because I did not have a degree 3 years ago. Now about to graduate with a relevant degree with a Distinction average whilst working as a full-time software engineer at other software-based companies.',
    double: false
  },
  {
    fullName: "Kyle Macey",
    handle: "kylemacey",
    website: "https://kylemacey.com",
    bio: "Engineering Lead, GitHub",
    avatar: "kylemacey.jpg",
    story:
      'I was rejected by GitHub twice before getting accepted into a Professional Services role. I since have founded an engineering team at GitHub and built some really cool stuff!',
    double: false
  },
  {
    fullName: "Zach Freed",
    handle: "ponchofreedo",
    website: "https://zachfreed.com",
    bio: "Tentrr",
    avatar: "zpfreed.jpg",
    story:
      'Out of the many, the best were in the same week. On Monday I was told I was "too UI-focused" for the first role at a larger company, on Wednesday I was "too UX-focused" for a smaller team, and then on Thursday someone commented "you seem pretty technical for a designer...this isn\'t a developer role."',
    double: false
  },
  {
    fullName: "Chad Ballay",
    handle: "Chad_Ballay",
    website: "https://chadballay.com",
    bio: "Site Reliability Engineer, Walmart",
    avatar: "chadballay.jpg",
    story:
      'Fresh out of college, I interviewed and ultimately wasn\'t hired for position working in Walmart\'s call center.  The feedback I was given that they felt I wasn\'t suited for a tech support role.  After a year of trying a career change into teaching high school math, I reinterviewed and was hired as a developer.  Don\'t let a single interviewer\'s bad feedback mar your self confidence.',
    double: false
  },
  {
    fullName: "Karan Thanvi",
    handle: "thanvi_karan",
    website: "https://twitter.com/thanvi_karan",
    bio: "Platform Engineer(SRE), PayPay, Tokyo JP",
    avatar: "karancode.jpg",
    story:
    'In junior high got rejected for the coaching class I wanted to join, ended up being the topper from the other batch at the end of 2 years. Got rejected from the university I wanted to get in for engineering. In unviersity placements, got rejected for many companies like Morgan Stanely from the last rounds, ended up in multinational one of the most prestigious companies Rakuten, Inc. that came to the campus. At the time of job switch, got rejected from many finTech companies. Currently at Japan\'s largest & fastest growing Mobile Payments company PayPay! The simple solution to this chain of failures & rejections is the chain of continous efforts. Just believe in yourself & never give up!',
    double: false
  },
  {
    fullName: "Vincenzo Chianese",
    handle: "d3dvincent",
    website: "https://vncz.codes",
    bio: "Eng. Team Leader, Stoplight, Austin TX",
    avatar: "vncz.jpeg",
    story:
    'I got rejected by Google and Twitter. Now I am the one periodically turning down their offers.',
    double: false
  },
  {
    fullName: "Advitya Gemawat",
    handle: "agemawat",
    website: "https://www.linkedin.com/in/agemawat/",
    bio: "Data Science @ UCSD, Former Data Scientist & ML Engineer Intern at Fortune 100 companies",
    avatar: "advitya_gemawat.jpg",
    story: "I cold messaged 600+ people on LinkedIn for referrals and got rejected from more than 40 positions consecutively with referrals in each, from multiple FAMANG companies and unknown start-ups at various stages of the interview process, before I secured a masters-level Data Scientist internship as an undergrad.\n Things were still far from perfect. I became one of the world's youngest contributors to an Apache project but the company where I worked refused to sponsor me as I am an international undergrad. It took me 9 months, 750+ applications, 30+ interviews, and countless rejections during COVID, and I got a ML Research Engineer position at their competitor and a FAMANG company. Your failures don't define you. Do not give up.",
    double: true
  },
  {
    fullName: "Andrei Martins",
    handle: "92amartins",
    website: "https://twitter.com/92amartins",
    bio: "Data Scientist @ Magazine Luiza (Large Brazilian Retailer)",
    avatar: "92amartins.jpg",
    story: "In 2016, I applied for a job at Netshoes. They rejected me without an interview, just by looking at my resumé. Next year, I got a job at Magazine Luiza. In 2019, Magazine Luiza acquired Netshoes. We're now happy peers.",
  },
	{
		fullName: "Drew Pearce",
		handle: "drewpearce",
		website: "https://twitter.com/drewpearce",
		bio: "Chatbot wrangler and full snack engineer for fun. Cloud platform engineer for a living.",
		avatar: "drewpearce.jpg",
		story: "One startup rejected me for a developer relations role because I didn't have enough dev experience. Another rejected me for a dev-centric support role because I failed a multiple choice Python exam. Within just a couple of months I moved into a cloud platform engineering role at my company. I write Python all day :grin:.",
		double: false
	},
  {
    fullName: "Dipanshi Bansal",
    handle: "Dipanshi23",
    website: "https://www.linkedin.com/in/dipanshi-bansal-8b7934183/",
    bio: "Upcoming Quantitative Research Intern at JP Morgan Chase, pre-final year Computer Science student",
    avatar: "dipanshi_bansal.jpg",
    story: "I kept trying and failing at various endeavors and today, I am content with where I am. My rejection story starts off from when I was applying for universities - I gave competitive exams and found myself scoring absurdly low. Had to take an year off to prepare again. I prepared well, was very optimisitic about my chances and yet - scored half of what I had been consistently scoring in practice tests. Despite all the demotivation, I prepared again in the remaining 2 months for another test and I have to thank my parents for their suppoort - I cracked that test and today study in one of the most prestigious engineering colleges in India in the best possible branch. Even in college, I have tried and failed. I tried for multiple hackathons and case challenges etc only to reach the final or pre-final round and lose. Always. I tried asking for referrals, even got to interview at a few companies like Amazon, Goldman Sachs - only to be rejected. But finally I got an offer from JPMC for a QR internship and I cannot be happier. It is not a role I had envisioned myself in, but maybe this role will lead me to a brighter future. But had I given up after all the failed coding tests, rejections faced in interviews, I probably would not have prepared as hard as I did for JPMC and today would not have that offer.",
    double: false
  },
];
